 <template>
  <div
    :class="['sixPage', pageSixAction ? 'animated pageFadeIn' : 'pageFadeOut']"
  >
    <div
      :class="['sixIconPng', sixTitShow ? 'imgAnimated imgFadeIn' : 'bgGray']"
    ></div>
    <div class="jxjPng"></div>
    <div
      :class="['titHeader', 'threeAnimated', 'fadeInUpBig']"
      v-if="sixTitShow"
    >
      创新人才机制，履行社会责任
      <span class="circle circleOne"></span>
      <span class="circle"></span>
    </div>
    <div class="titBox">
      <!-- <h4 class="tit threeAnimated fadeInUpBig" v-if="sixTitShow">
        校企教学新模式、理论实践新认识
      </h4> -->
      <p class="textMian animated delay fadeIn" v-if="sixTitShow">
        2019年08月，我院与南京林业大学签订校企合作协议，并设立“东华生态奖学金”，联合开办“森林资源调查规划培训班”。  
        2020年01月16日，我院来到界首市光武镇刘寨小学开展捐资助学活动，积极履行企业社会责任。
      </p>
    </div>
    <div class="bwBox" v-if="sixBtnShow" @click="changeHue">
      <div class="wave wave4"></div>
      <div class="wave wave3"></div>
      <div class="wave wave1"></div>
      <div class="wave waveOne">
        <!-- <img :src="baseUrl + 'img/dhShare/dianSix.png'" class="textAmation" /> -->
        <img :src="baseUrl + 'img/dhShare/dianIcon.png'" class="textAmation" />
      </div>
    </div>
    <div :class="['imgMainBox', sixTitShow ? 'imgMainBoxShow' : '']">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperChild">
        <swiper-slide
          class="slideItem"
          v-for="(item, index) in slideList"
          :key="index"
        >
          <van-image
            fit="cover"
            @click="seeImg(item, index)"
            :src="baseUrl + item.imgUrl"
          />
        </swiper-slide>
      </swiper>
    </div>

    <van-overlay @click="bigImgShow = false" class="tkMain" :show="bigImgShow">
      <div class="wrapper">
        <!-- <div class="swiperThree"> -->
        <!-- <swiper
            :options="swiperOptionTwo"
            ref="bigSwiper"
            class="swiperChildTwo"
          >
            <swiper-slide
              class="slideItem"
              v-for="(item, index) in slideList"
              :key="index"
            > -->
        <van-image
          fit="cover"
          :src="baseUrl + bigImgUrl + '?x-oss-process=image/resize,p_50'"
        />
        <!-- </swiper-slide>
          </swiper> -->
        <!-- </div> -->
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@/assets/style/animate.min.less";

export default {
  name: "sixPage",
  props: {
    landscapeType: {
      type: Boolean,
      default: false,
    },
    newIndex: {
      type: String,
    },
  },
  components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      baseUrl: process.env.BASE_URL,
      typePage: false,
      sixTitShow: false,
      pageSixAction: false,
      sixBtnShow: true,
      bigImgShow: false,
      swiperOption: {
        loop: false,
        slidesPerView: 3, //数量
        spaceBetween: 15, //间距
        initialSlide: 1,
        centeredSlides: true,
        direction: "horizontal", //设置水平horizontal还是垂直vertical
      },
      swiperOptionTwo: {},
      bigImgUrl: "",
      slideList: [
        {
          imgUrl: "img/dhShare/sixK002.jpg",
        },
        {
          imgUrl: "img/dhShare/sixK003.jpg",
        },
        {
          imgUrl: "img/dhShare/sixK001.jpg",
        },
        {
          imgUrl: "img/dhShare/sixK004.jpg",
        },
        {
          imgUrl: "img/dhShare/sixK005.jpg",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.typePage = this.landscapeType;
      this.initPage();
    });
  },
  methods: {
    initPage() {
      this.pageSixAction = true;
    },
    changeHue() {
      this.sixBtnShow = false;
      this.sixTitShow = true;
    },
    seeImg(item, index) {
      let newItemArr = [];

      // this.swiperOptionTwo = {
      //   loop: false,
      //   direction: "vertical", //设置水平horizontal还是垂直vertical
      //   initialSlide: index,
      // };

      this.bigImgShow = true;
      this.bigImgUrl = item.imgUrl;
      // this.slideList.forEach((item) => {
      //   newItemArr.push(
      //     this.baseUrl + item.imgUrl + "?x-oss-process=image/resize,p_50"
      //   );
      // });
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  watch: {
    landscapeType: function (newVal) {
      this.typePage = newVal;
    },
    newIndex: function (newValue) {
      if (newValue == "5") {
        this.pageSixAction = true;
      } else {
        this.pageSixAction = false;
      }
    },
  },
};
</script>
<style lang="less">
.sixPage {
  width: 100%;
  height: 100%;
  background-image: url("../../../../../public/img/dhShare/slideSix.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: relative;
  .sixIconPng {
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/sixIcon.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: relative;
    -webkit-filter: grayscale(100%); /* Chrome, Safari, Opera */
    filter: grayscale(100%);
  }
  .jxjPng {
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/jxjIcon.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
  .titHeader {
    top:115px;
    right: -55px;
    border: 1px solid #643d3b;
    color: #643d3b;
    .circle {
      border: 1px solid #643d3b;
    }
  }
  .titBox {
    position: absolute;
    top: 20px;
    right: 25px;
    // .tit {
    //   position: absolute;
    //   width: 300px;

    //   left: 7px;
    //   font-size: 16px;
    //   color: #7a3804;

    //   font-weight: 600;
    // }
    .textMian {
      width: 220px;
      position: absolute;
      top: 40px;
      left: 10px;
      font-size: 12px;
      color: #643d3b;
      text-align: justify;
      opacity: 0;
    }
  }

  /** css3动画效果 **/
  @-webkit-keyframes fadeInLeftBig {
    0% {
      opacity: 0;
      -webkit-transform: translateX(-1000px);
      -ms-transform: translateX(-1000px);
      transform: translateX(-1000px);
    }

    100% {
      opacity: 1;
      -webkit-transform: translateX(0);
      -ms-transform: translateX(0);
      transform: translateX(0);
    }
  }

  @keyframes fadeInLeftBig {
    0% {
      opacity: 0;
      -webkit-transform: translateX(-500px);
      -ms-transform: translateX(-500px);
      transform: translateX(-500px);
    }

    100% {
      opacity: 1;
      -webkit-transform: translateX(0);
      -ms-transform: translateX(0);
      transform: translateX(0);
    }
  }

  .fadeInUpBig {
    -webkit-animation-name: bounceInUp;
    animation-name: bounceInUp;
  }
  .threeAnimated {
    -webkit-animation-duration: 2s;
    animation-duration: 2s;
  }

  .imgMainBox {
    display: none;
    position: absolute;
    bottom: 25px;
    left: 0;
    // -webkit-transform: rotate(90deg);
    // transform: rotate(90deg);
    z-index: 999;
    width: 100%;

    .swiperChild.swiper-container {
      width: 320px;
      height: 120px;
      .swiper-wrapper {
        margin-top: 15px;
        .slideItem.swiper-slide {
          width: 110px;
          height: 95px;
          background-color: #fff;
          z-index: 1000;
          border-radius: 10px;
          -webkit-border-radius: 10px;
          padding: 5px 5px;
          opacity: 0.7;
          .van-image {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            img {
              border-radius: 8px;
            }
          }
        }
        .slideItem.swiper-slide.swiper-slide-active {
          transform: scale(1.2);
          opacity: 1;
        }
      }
    }
  }
  .tkMain.van-overlay {
    position: absolute !important;
    width: 100% !important;
    height: 75% !important;
    left: 0;
    top: 0;
    z-index: 9999;
    background-color: rgba(225, 225, 225, 0);
    overflow: hidden;

    .wrapper {
      position: absolute;
      width: 300px;
      height: 450px;
      background-color: #fff;
      padding: 5px 5px;
      left: 50%;
      top: 50%;
      margin-left: -150px;
      margin-top: -210px;
      border-radius: 10px;
      -webkit-border-radius: 10px;
    }
    // .swiperChildTwo.swiper-container {
    //   width: 230px;
    //   height: 380px;
    //   border-radius: 10px;
    //   .slideItem.swiper-slide {
    //     // z-index: 1000;
    //     width: 230px;
    //     height: 380px;
    //     border-radius: 10px;
    //     -webkit-border-radius: 10px;
    .van-image {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      img {
        border-radius: 8px;
      }
    }
    //   }
    // }
  }
  .imgMainBox.imgMainBoxShow {
    display: block;
  }
}
</style>